import * as types from './actionTypes';  
import brokerDealerListApi from '../api/brokerDealerListApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doBrokerDealerList() {

  return {
    type: types.DO_BROKERDEALER_LIST
  };
}

export function doBrokerDealerListRes(data) {  
  return {
    type: types.DO_BROKERDEALER_LIST_RES, 
    data
  };
}

export function getBrokerDealerList() {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      brokerDealerListApi.doBrokerDealerList().then(data => {
        dispatch(doBrokerDealerListRes(data));
        dispatch(doBrokerDealerListRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}